// ====================================================================
// (辉哥 9/19 15:02 拍板修 webpack DCE 砍 nested safeExtend bug):
//   - 之前 5 个 sub-files (PhoneLogin/SignUp/ForgotPassword/IgnoreSearchUser/modifyUserPage)
//     各自 define nested `function safeExtend(...)`, webpack DCE 砍了函数体
//     只保留调用 `safeExtend(...)`, ReferenceError: safeExtend is not defined
//   - 修法: 把 safeExtend / safeOverride 提取到共享 utils, sub-files import 共享版本
//   - webpack DCE 不会砍 named export
//
// 用途: ziven-core lazy extend vendor class 时 (vendor module 未 ready 的兜底)
//   - safeExtend / safeOverride 内部 try/catch, vendor module undefined 时不抛错
//   - 替代 ziven-core 各 sub-files 之前用的 nested function declaration (DCE 砍)
// ====================================================================
import { extend, override } from 'flarum/common/extend';
export function safeExtend(targetOrClass, method, fn) {
  try {
    // 兼容 Class (typeof === 'function' 走 .prototype) 或 prototype 对象
    const target = typeof targetOrClass === 'function' ? targetOrClass.prototype : targetOrClass;
    if (!target || typeof target !== 'object') {
      console.warn('[ziven-core] safeExtend skipped (target undefined):', method);
      return null;
    }
    return extend(target, method, fn);
  } catch (e) {
    console.warn('[ziven-core] safeExtend failed:', method, e && e.message);
    return null;
  }
}
export function safeOverride(targetOrClass, method, fn) {
  try {
    const target = typeof targetOrClass === 'function' ? targetOrClass.prototype : targetOrClass;
    if (!target || typeof target !== 'object') {
      console.warn('[ziven-core] safeOverride skipped (target undefined):', method);
      return null;
    }
    return override(target, method, fn);
  } catch (e) {
    console.warn('[ziven-core] safeOverride failed:', method, e && e.message);
    return null;
  }
}

// 挂 window 保留旧 pattern (sub-files 改 import 后可移除, 兼容 lazy chunk 旧依赖)
window.__zivenCoreSafeExtend = safeExtend;
window.__zivenCoreSafeOverride = safeOverride;
flarum.reg.add('ziiven-ziven-core', 'forum/utils/safeExtend', { safeExtend: safeExtend,safeOverride: safeOverride, });